const authTokenStorageKey = "lenses.authToken";

export const readAuthToken = (): string => {
  if (typeof window === "undefined") return "";
  const sessionToken = window.sessionStorage.getItem(authTokenStorageKey) ?? "";
  if (sessionToken) return sessionToken;

  const legacyToken = window.localStorage.getItem(authTokenStorageKey) ?? "";
  if (legacyToken) {
    window.sessionStorage.setItem(authTokenStorageKey, legacyToken);
    window.localStorage.removeItem(authTokenStorageKey);
  }
  return legacyToken;
};

export const writeAuthToken = (token: string): void => {
  window.sessionStorage.setItem(authTokenStorageKey, token);
  window.localStorage.removeItem(authTokenStorageKey);
};

export const clearAuthToken = (): void => {
  window.sessionStorage.removeItem(authTokenStorageKey);
  window.localStorage.removeItem(authTokenStorageKey);
};
